import React from 'react';

/**
 * KG Inicis V2 일반결제 requires the buyer's mobile number — PortOne's
 * /api/prepare/v2 otherwise 400s before any payment window opens. Shared by
 * the plan checkout (ManageMembershipPage STEP_DETAILS) and the pack
 * checkout (PackCheckoutStep.jsx): both go through the same PortOne window
 * and have the same requirement.
 *
 * `invalid` is computed by the caller (isValidKrMobile) rather than imported
 * here, so this stays a plain presentational component with no dependency on
 * where that validator lives.
 */
export default function BuyerPhoneField({ isKo, value, onChange, invalid, idPrefix = 'buyer' }) {
  const inputId = `${idPrefix}-phone`;
  const helpId = `${idPrefix}-phone-help`;
  return (
    <div className="mmpage-phone-field">
      <label htmlFor={inputId}>
        {isKo ? '휴대폰 번호' : 'Mobile number'}
        <span className="mmpage-required" aria-hidden="true"> *</span>
      </label>
      <input
        id={inputId}
        type="tel"
        inputMode="numeric"
        autoComplete="tel"
        placeholder="01012345678"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-invalid={invalid}
        aria-describedby={helpId}
      />
      <small id={helpId}>
        {invalid
          ? (isKo ? '올바른 휴대폰 번호를 입력해 주세요.' : 'Enter a valid Korean mobile number.')
          : (isKo ? '결제사(KG이니시스) 요구사항이며, 저장되지 않습니다.'
                  : 'Required by the payment provider (KG Inicis). Not stored.')}
      </small>
    </div>
  );
}
